import { render, staticRenderFns } from "./DelegationDetail.vue?vue&type=template&id=15481001&scoped=true&"
import script from "./DelegationDetail.vue?vue&type=script&lang=js&"
export * from "./DelegationDetail.vue?vue&type=script&lang=js&"
import style0 from "./DelegationDetail.vue?vue&type=style&index=0&id=15481001&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15481001",
  null
  
)

export default component.exports